/* POVA — "Where to buy" outbound click tracking.
 * One delegated listener publishes a `where_to_buy_click` analytics event when a
 * visitor clicks a retailer / where-to-buy link. A Shopify Custom Pixel (added in
 * Admin by the owner) subscribes to this event and forwards it to GA4.
 *
 * Covered triggers:
 *   - .r-cta     retailer partner links on the Where to buy page (sections/page-shop)
 *   - .pdp-where the PDP "Where to buy" showcase CTA (sections/xp-commerce)
 *   - nav/footer "Where to buy" pills (menu-driven links, matched by text in chrome)
 *
 * Payload: { retailer_name, product, destination_url }. No-ops silently when the
 * Shopify analytics API is absent. Capture-phase so it still fires before the
 * browser follows the link.
 *
 * IDEMPOTENT: the one-time guard below ensures the delegated listener is bound at
 * most ONCE per page, so one user click always fires exactly one event — even if
 * this script is ever evaluated/injected twice (e.g. a duplicate include or a
 * theme-editor section re-render). Without the guard, a second init would add a
 * second listener and double-publish every click.
 */
(function () {
  "use strict";
  if (window.__povaWtbTrackBound) return;
  window.__povaWtbTrackBound = true;
  function retailerName(a, isRetailer, text) {
    if (isRetailer) {
      var card = a.closest(".retailer-card");
      var h = card && card.querySelector("h3");
      if (h && h.textContent.trim()) return h.textContent.trim();
    }
    var label = a.getAttribute("aria-label");
    return (label && label.trim()) || text || "";
  }
  document.addEventListener("click", function (e) {
    var a = e.target && e.target.closest ? e.target.closest("a") : null;
    if (!a) return;
    var text = (a.textContent || "").trim().toLowerCase();
    var isRetailer = a.classList.contains("r-cta");
    var isPdpWhere = a.classList.contains("pdp-where");
    var inChrome = a.closest("footer, .footer, nav, .nav-drawer, header, .site-banner");
    var isPill = !!inChrome && text.indexOf("where to buy") !== -1;
    if (!isRetailer && !isPdpWhere && !isPill) return;
    var product = "";
    try { product = document.body.getAttribute("data-product-id") || ""; } catch (err) {}
    var payload = {
      retailer_name: retailerName(a, isRetailer, (a.textContent || "").trim()),
      product: product,
      destination_url: a.href || a.getAttribute("href") || ""
    };
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === "function") {
        window.Shopify.analytics.publish("where_to_buy_click", payload);
      }
    } catch (err) {}
  }, true);
})();
